export default {
    textBtn: {
        btnSearch:  'Search',
        btnSend:    'Send',
        btnUpdate: 	'Update',
        btnDetail: 	'Detail',
        btnSwitch: 	'Change',
    },
    navbarMain: {
        search:     'Search',
        filter:     'Filter',
        delete:     'Delete',
        password:   'Change password',
        goOut:      'Exit',
        help:       'Help',
        textSelectSwitchTenants:  'Select a tenants',
        errorOnChangeTenant: 'Error when try to change of tenant',
    },
    navbarInternal: {
        processes:          'Processes',
        processesManage:    'Manage processes',
        radar:              'Radar',
        reports:            'Reports',
        search:             'Search',
        updates:            'Updates',
        customers:          'Customers',
        users:              'Users',
        regulatoryAffairs:  'Manage regulatory affairs',
        rules:              'Rules',
        diagnosis:          'Diagnosis',
        topicsSubtopics:    'Topics/SubTopics',
        reportStructuring:  'Structuring Reports',
        monthlyStatistics:  'Monthly Statistic',
    },
    gridHeaderText: {
        expiration:     'EXPIRATION',
        periodicity:    'PERIODICIDAD',
        manager: 'MANAGER',
        textManager: 'Manager',
        textErrorManager:       '*Select a Manager',
        exercise:       'ACTIVITY',
        state:          'STATE',
        evidence:       'EVIDENCE',
        observations:   'OBSERVATIONS',
        obligation:     'DUTY',
        compliance:     'COMPLIANCE',
        process:        'PROCESS',
        affair:         'SUBJECT',
        description:    'DESCRIPTION',
        date:           'DATE',
        support: 		'SUPPORT',
        businessName:   'BUSINESS NAME',
        email:          'E-MAIL',
        phone:          'PHONE',
        city:           'CITY',
        direction:      'DIRECTION',
        user:           'USER',
        profile:        'PROFILE',
        name:           'NAME',
        identification: 'IDENTIFICATION CARD',
        actions:        'ATTACHED',
        keywords:       'KEYWORDS',
        topic:          'TOPIC',
        subtopic:       'SUBTOPIC',
        prefix:         'PREFIX',
        article:        'ARTICLE',
        standard_type:  'STANDARD TYPE',
        number:         'NUMBER',
        year:           'YEAR',
        denomination:   'DENOMINATION',
        content:        'CONTENT',
        tenant:         'TENANT',
        publicPrivate:  'PUBLIC / PRIVATE'
    },
    textLogin: {
        textEmail:      'Email',
        textPassword:   'Password',
    },
    textDashboard: {
        statisticsDataVen:  'Expired',
        statisticsData30:   '30 days',
        statisticsData60:   '60 days',
        statisticsData90:   '90 days',
        titleExecuted: 	    'Executed',
        titleCompliance:    'Compliance',
        titleCalendar:      'Calendar',
        today:              'Today',
        noEvents:           'No Events',
        all:                'All',
        radar:              'Radar',
        updates:            'Updates',
    },
    textProcesses: {
        textTitle:                      'Processes',
        statisticsComplianceExpired:    'EXPIRED',
        statisticsFulfillmentsExpire:   'Soon to expire',
        statisticsFulfillmentsExpire2:   'Soon to expire',
        statisticsUpdates:              'Updates',
        textTitleCompliance:            'Compliance',
        textTitleObligation: 			'Duty',
        textTitleAffair:                'Regulatory Affair',
        textTitleDescription: 			'Description',
        textTitleRules: 				'Rules',
        textTitleHistory: 				'Record',
        textTitleState: 				'State',
        textTitleEvidence: 				'Evidence',
        textTitleUpdate: 				'Updtae',
        textClassification:             'Classification',
        textTitleExpired:               'Pending',
        textTitleExecuted:              'Executed'
    },
    textReports: {
        textTitle:              'Reports',
        btnTextNewReport:       'New Report',
        btnTextExportExcel:     'Export to Excel',
        textFormUser:           'User',
        textFormObject: 	    'Objects',
        textFormProcess:        'Process',
        textFormTypeAffair:     'Affair type',
        textFormStartdate:      'Start date',
        textFormFinaldate:      'Final date',
        textFormSelectReport:   'Seleccione un reporte',
        textActiveFilters:      'Active Filters: ',
        btnGenerating_report:      'Generating ...'
    },
    textRadar: {
        textFormSelectProcess:  'Select a process',
        textFormSelectSubject:  'Select a subject',
        textFormDescription:    'Description',
    },
    textCustomers: {
        textTitle:            'Customers',
        textBtnNewCustomers:  'New client'
    },
    textUsers: {
        textTitle:                    'Users',
        textBtnNewUser:               'New user',
        textBtnBulkLoad:              'Import users',
        textBtnBackStructuringUsers:  'Return users list',
        textBtnProcessExcel:          'Process excel'
    },
    textSearch: {
        textTitle:                  'Search',
        norms: {
            tittle:                 'Tittle',
            denomination:           'Denomination',
            affairs:                'Affairs',
            compliance:             'Compliance',
        },
        themes: {
            theme:                  'Theme',
            subtheme:               'Subtheme',
            affair:                 'Affair',
            complianceObligation:   'Compliance/Obligation',
            norms:                  'Related Norms',
        }
    },
    textTenants: {
        textFormSelect:             'Select',
        textFormTypeBusinessName:   "Enter the Customer's name",
        textTittleState: 		    'State',
        textTittleBusinessName:     'Business Name',
        textTittleEmail:            'Email',
        textTittlePhone: 		    'Phone',
        textTittleCelPhone: 	    'Celphone',
        textTittleCountry:          'Country',
        textTittleDepartament:      'Departament',
        textTittleMunicipality:     'Municipality',
        textTittleAddress:          'Address',
        textTittleThemes:           'Themes',
        textTittleLicenses:         'Licenses',
        textTittleClient:           'Client',
        textTittleNotifications:    'Notifications',
        notification: {
            textInactive:           'Active',
            textActive:             'Inactive',
        },
        textTittleStructuringUser:  'Structuring User/s',
        textTittleLogo:             'Logo',
        textTittleBanner:           'Banner - Dashboard Image',
        textErrorState:             '*Select a State',
        textErrorMunicipality:      '*Select a Municipality',
        textErrorBusinessName:      '*Type Business Name',
        textErrorEmail:             '*Type a valid email',
        textPagination:             'Step {#} to {$}',
        textSaveButton:             'Save',
        textNextButton:             'Next',
        textPreviousButton:         'Previous',
        infoBrowser: {
            textTittle:             'Remember that',
            textRecomendation1:     'This image will be visible in the emails that are sent in the signing process of your clients.',
            textRecomendation2:     'Allowed Formats: JPG, JPEG, PNG, BMP',
            textRecomendation3:     'Maximum dimensions (pixels): 500x300',
            textRecomendation4:     'Minimum dimensions (pixels): 100x30',
            textRecomendation5:     'Maximum image weight: 5MB',
        },
        textCloneThemes:            'Clone themes',
        textAssociatedTopics:       'Associated topics',
    },
    textProcessesStructure:{
        textTitle:                  'Process',
        textName:                   'Name',
        textClassification:         'Classification',
        textResponsable:            'Responsable',
        textDescription:            'Description',
        textTeam:                   'Team',
        textQuery:                  'Query',
        textActions:                'Actions',
        textFormSelect:             'Select',
        textBulkLoad:               'Bulk Load',
        textSave:                   'Save',
        textCancel:                 'Cancel',
        textErrorName:              '*Type Name',
        textErrorResponsable:       '*Select a Responsable',
        textErrorClassification:    '*Type Classification',
        textBtnNewProcess:          'New Process',
        textBtnLoadProcess:         'Load Process',
    },
    textAffairAssociation:{
        textAssociationButton:      'Add Affair',
        textAffairGrid:
        {
            affair:                 'Affair',
            interest:               'Interest',
            theme:                  'Theme',
            subtheme:               'Subtheme',
            delete:                 'Disassociate'
        },
    },
    textSessionExpired: {
        textHeader:             'Session Expired',
        textBody:               'Your session is expired'
    },
    textUpdates: {
        textTitle:  'Updates',
    },
    textPassword: {
        textFormOldPassword:    'Enter current password',
        textFormNewPassword:    'Enter new password',
        textFormRepeatPassword: 'Confirm password',
    },
    textRegulatoryAffairs: {
        textTitle:          'Manage regulatory affairs',
        textLabelTitle:     'Title',
        textLabelPeriodicidad:  'Periodicidad',
        textFormAffair:     'Affairs',
        textFormTopic:      'Topic',
        textFormSubTopic:   'Subtopic',
        textFormKeywords:   'Keywords',
        textBtnNew:         'New regulatory affairs',
        textErrorAffair:    '*Select a Subject',
        textErrorTopic:     '*Select a Topic',
        textErrorSubtopic:  '*Select a Subtopic',
        textTitleCompliance:'Compliance  / Homework',
    },
    textDiagnosis: {
        textTitle: 'Diagnosis'
    },
    textDetailRule: {
        processes:  'Processes',
        interest:   'Interest',
        loadRule:   'Load rules'
    },
    terms: {
        labels: {
            terms: 'Terms and conditions',
        },
        messages: {
            loading: 'Loading...'
        },
        buttons: {
            accept: 'Accept',
            cancel: 'Cancel',
            processing: 'Processing...'
        }
    },
    topicsSubTopics: {
        labels: {
            topics: 'Topics',
            subtopics: 'Subtopics',
            add: 'Add',
            update: 'Update',
        },
        buttons: {
            add: 'Add',
            edit: 'Edit',
            save: 'Save',
            update: 'Update',
            delete: 'Delete'
        },
        placeholder: {
            select_topic: 'Select a topic',
            subtopic_name: 'Subtopic name',
            topic_name: 'Topic name',
        },
        messages: {
            loading: 'Loading...',
            processing: 'Processing...',
            empty_topics: 'Topics are empty currently',
            empty_sub_topics: 'Subtopics do not exist for the actual topic selected.'
        },
        validations: {
            topicId: '* Tema al que pertenecera el subtema es requerido.',
            subtopic: '* Campo nombre del subtema es requerido.',
            topic: '* Campo nombre del tema es requerido.'
        }
    }
}
